import store from "@/store";
import {FuneralPlanTab} from "@/shared/domain/enum/funeral-plan-tab.model";
import {RouteRecordRaw} from "vue-router";
import RouteSettings from "@/router/route.settings";

/**
 * LOST_SOMEONE products routes
 */

const LostSomeoneRoute: RouteRecordRaw = {
  alias: 'lost-someone',
  path: 'imediato',
  name: 'Perdi Alguém',
  component: () => import("@/components/BasicRouter.vue"),
  beforeEnter: (to, from, next) => {
    if(store.getters.getFuneralPlanTab == FuneralPlanTab.PREVENT) {
      store.commit('resetValues');
    }
    store.commit('changeFuneralPlanTab', FuneralPlanTab.LOST_SOMEONE);
    next();
  },
  children: [
    {
      path: '',
      name: 'Perdi Alguém ',
      component: () => import("@/views/WelcomeTabPage.vue"),
    },
    // {
    //   path: 'group',
    //   component: () => import("@/views/FuneralPlanGroupPage.vue"),
    //   beforeEnter: (to, from, next) => {
    //     RouteSettings.checkForCacheData();
    //     RouteSettings.forceToFilterByLegacySupplierCompaniesId(next);
    //   },
    // },
    {
      path: 'group-parque-brasil',
      component: () => import("@/views/FuneralPlanFilterPage.vue"),
      beforeEnter: (to, from, next) => {
        RouteSettings.checkForCacheData();
        // RouteSettings.newStores();
        RouteSettings.forceToFilterByLegacySupplierCompaniesId(true);
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
    },
    {
      path: 'filter',
      beforeEnter: (to, from, next) => {
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        solidBackground: true
      },
      component: () => import("@/views/FuneralPlanFilterPage.vue")
    },
    {
      path: 'location',
      beforeEnter: (to, from, next) => {
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        solidBackground: true
      },
      component: () => import("@/views/FuneralPlanLocationPage.vue")
    },
    {
      path: 'supplier',
      redirect: {name: 'lost-someone-fornecedor'}
    },
    {
      name: 'lost-someone-fornecedor',
      path: 'fornecedor',
      beforeEnter: (to, from, next) => {
        store.commit('resetValues');
        store.commit('changeFuneralPlanTab', FuneralPlanTab.LOST_SOMEONE);
        store.commit('changeInitPurchaseUrl', to.fullPath);
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
        solidBackground: true
      },
      component: () => import("@/views/plans/supplier/FuneralPlanSupplierPage.vue")
    },
    {
      path: 'contract',
      redirect: {name: 'lost-someone-pacote'}
    },
    {
      name: 'lost-someone-pacote',
      path: 'pacote',
      beforeEnter: (to, from, next) => {
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
      },
      component: () => import("@/views/funeral-plan-contract/FuneralPlanContractPage.vue")
    },
    {
      path: 'payment',
      redirect: {name: 'lost-someone-pagamento'}
    },
    {
      name: 'lost-someone-pagamento',
      path: 'pagamento',
      beforeEnter: (to, from, next) => {
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
      },
      component: () => import("@/views/payment/PaymentContractPage.vue")
    },
    {
      path: 'success',
      redirect: {name: 'lost-someone-pagamento-realizado'}
    },
    {
      name: 'lost-someone-pagamento-realizado',
      path: 'pagamento-realizado',
      beforeEnter: (to, from, next) => {
        RouteSettings.checkRouteDependecies(to.path, next, 1);
      },
      meta: {
        spacingTop: true,
      },
      component: () => import("@/views/payment/payment-success/FuneralPlanContractSuccessPage.vue")
    }
  ]
}

export default LostSomeoneRoute;
